import * as Yup from 'yup';

export const LimitedTPRecommendationSchema = Yup.object().shape(
  {
    provision_description: Yup.string().optional().notRequired(),
    considered_factors: Yup.string().optional().notRequired(),
    explanation: Yup.string().trim().required().min(60),
    date_start: Yup.string().trim().required(),
    duration: Yup.number().positive().required(),
  },
  [['provision_description', 'considered_factors']],
);

export const FullTPRecommendationSchema = Yup.object().shape(
  {
    provision_description: Yup.string().when('considered_factors', {
      is: (considered_factors: string | null) => !considered_factors || considered_factors === '',
      then: () => Yup.string().trim().required(),
      otherwise: () => Yup.string().nullable(),
    }),
    considered_factors: Yup.string().when('provision_description', {
      is: (provision_description: string | null) =>
        !provision_description || provision_description === '',
      then: () => Yup.string().trim().required().min(60),
      otherwise: () => Yup.string().nullable(),
    }),
    explanation: Yup.string().trim().required().min(60),
    date_start: Yup.string().trim().required(),
    duration: Yup.number().positive().required(),
  },
  [['provision_description', 'considered_factors']],
);

export const RecommendationServiceSchema = Yup.object().shape({
  hours: Yup.number().nullable().min(0).required(),
  units: Yup.number().nullable().min(0).optional(),
  frequency: Yup.string().trim().required(),
});

export const MandatoryServiceSchema = Yup.object().shape({
  hours: Yup.number().min(1).required(),
  units: Yup.number().min(0).optional(),
  frequency: Yup.string().trim().required(),
});
